import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API } from 'utils/globalApiServices';
import { toastFlashMessage } from 'utils';
import { ROLEPLAY_CACHE_KEYS } from 'features/roleplay/Roleplay.queries';

const mutationFn = async ({ roleplay }) => {
  const url = `v2/roleplays/custom/`;
  const data = await API.post(url, roleplay);
  return data;
};

const useCreateCustomInteractiveRoleplayMutation = () => {
  const queryClient = useQueryClient();
  return useMutation(mutationFn, {
    onSuccess: (response) => {
      toastFlashMessage(response?.message, 'success');
      queryClient.invalidateQueries([ROLEPLAY_CACHE_KEYS.ASSIGNED_TO_ME]);
      queryClient.invalidateQueries([ROLEPLAY_CACHE_KEYS.PROGRESS_GRAPH]);
      queryClient.invalidateQueries([ROLEPLAY_CACHE_KEYS.TO_REVIEW]);
      queryClient.invalidateQueries([ROLEPLAY_CACHE_KEYS.MY_TEAM]);
    },
  });
};

export default useCreateCustomInteractiveRoleplayMutation;
